import React from "react"; 
import "../styles/AboutUs.css"; // Import CSS file
import { FaWhatsapp, FaEnvelope } from "react-icons/fa"; // Import WhatsApp and Email icons

import { Container, Row, Col, Card } from "react-bootstrap";

const AboutUs = () => {
  return (
    <>
    <section id="about" className="about-section">
      <div className="about-overlay">
        <div className="about-title-container">
          <h2 className="about-title p-5">ABOUT US</h2>
        </div>

        <div className="about-gap"></div>

        <div className="about-content-container">
          <p className="about-intro">
            We offer supply chain fulfillment, asset recovery, reverse logistics, recycling, and distribution of products.
          </p>
          <div className="about-text">
            <p>
              Bhanot International LLC works with major US and international carriers, OEMs, and service centers to maximize inventory.
            </p>
            <p>
              We ensure long-term partnerships and provide sustainable solutions for excess inventory liquidation.
            </p>
          </div>
        </div>

        <div className="about-gap"></div>

        <div className="about-content-wrapper">
          <div className="about-content-container">
            <p>
              Our specialized teams provide one-stop solutions for surplus inventory management.
            </p>
          </div>
          <div className="about-button-container">
            {/* <button className="about-button">CONTACT US</button> */}
          </div>
        </div>
      </div>
    </section>
    (
    <div className="company-page">
      {/* Header Section */}
      {/* <div className="company-header">
      </div> */}

      {/* Company Info Section */}
      <Container>
        <Row className="justify-content-center">
          {/* Company Name */}

          <Col md={4} lg={3} className="d-flex">
            <Card className="info-card w-100">
              <Card.Body>
                <h3 className="text-center">Contact Info</h3>
                <p className="text-center">
                  <FaWhatsapp color="green" size={20} /> +995-571075228
                </p>
                  <p className="text-center">
                  <FaWhatsapp color="green" size={20} /> +995-504220383
                </p>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4} lg={3} className="d-flex">
            <Card className="info-card w-100">
              <Card.Body>
                <h3 className="text-center">Company Emails</h3>
                  <p className="text-center">
                  <FaEnvelope color="red" size={20} /> service@bhanottrade.com
                </p>
                  <p className="text-center">
                  <FaEnvelope color="red" size={20} /> Gaurav@bhanottrade.com
                </p>
                    <p className="text-center">
                  <FaEnvelope color="red" size={20} /> Info@bhanottrade.com
                </p>
              </Card.Body>
            </Card>
          </Col>

          {/* Address */}
          <Col md={4} lg={3} className="d-flex">
            <Card className="info-card w-100">
              <Card.Body>
                <h3 className="text-center">Address</h3>
                <p className="text-center">Georgia, Tbilisi, Krtsanisi District</p>
                <p className="text-center">Nino and Ilia Nakashidze Street, N1</p>
                <p className="text-center">Building N3, Apartment N3</p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
    </>
  );
};

export default AboutUs;
